import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ValidationService } from '../../services/validation.service';
import CryptoJS from "crypto-js"

import { CommonService } from '../../services/common.service';

import { empty } from 'rxjs/Observer';
declare var $: any;
declare var Material: any;
declare var jQuery: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm;

    verifyOTPForm: any;
    otpPhone: any;
    isFailed: any = false;
    isFailedM: any = false;
    varified: any = false;
    // data:any;
    tempToken: any;
    otp: any = '';
    is_super_admin:string = '';
    constructor(
        private authService: AuthService, private router: Router,
        private cookieService: CookieService, 
        private validationService: ValidationService
        ) { }

    ngOnInit() {
        // Check if user is logged in then don't show login form and redirect to dashboard.
        if (this.authService.isAuthenticated()) {
            this.router.navigate(['dashboard']);
        }

        this.loginForm = new FormGroup({
            user_name: new FormControl("", Validators.compose([
                Validators.required
            ])),

            password: new FormControl("", Validators.compose([
                Validators.required
            ])),
        });
    }

    // Login Functionality
    onSubmit = function (credentials) {
        credentials.user_name=CryptoJS.AES.encrypt(credentials.user_name, "wazsurvey2021").toString()
        credentials.password=CryptoJS.AES.encrypt(credentials.password, "wazsurvey2021").toString()
        this.data = {};
        //this.tempToken.reset;
        if (this.loginForm.valid) {

            //credentials.ipaddress = '171.49.142.51';
            $('#btnLogin').button('loading').queue();
            this.authService.login(credentials).subscribe(data => {
                if (data.success) {
                    localStorage.removeItem('refresh');
                    this.tempToken = data.token;
                    let otp_bytes = CryptoJS.AES.decrypt(data.user.otp.toString(), "wazsurvey2021");
                    var otp = otp_bytes.toString(CryptoJS.enc.Utf8);
                    this.otpPhone = otp;//data.user.otp;
                    console.log( this.otpPhone)
                    this.is_super_admin = data.user.is_super_admin ? data.user.is_super_admin : false;


                    $.growl.notice({ title: 'Success', message: "Please verify otp!" });
                    $('.btn-sendOTP').removeAttr('disabled');
                    $('.btn-next').removeAttr('disabled');


                    $('#verifyOTP').modal('show');
                    this.otp = '';

                    // this.authService.storeWebToken(data.token);
                    // this.router.navigate(['dashboard']);
                    // this.authService.getSurveyTypeList().subscribe(data=>{
                    //     if(data.success) {
                    //         this.cookieService.set('surveyTypeList',JSON.stringify(data.type));
                    //     }
                    // });
                }
                else {
                    $.growl.error({ title: 'Error', message: data.error });
                }
                $('#btnLogin').button('reset').dequeue();
            });
        }
        else {
            this.validationService.validateAllFormFields(this.loginForm);
        }
    }






    ////---------------bakcup ------------------
    // // Login Functionality
    // onSubmit = function(credentials) {

    //     if(this.loginForm.valid){

    //         //credentials.ipaddress = '171.49.142.51';

    //         $('#btnLogin').button('loading').queue();
    //         this.authService.login(credentials).subscribe(data=>{
    //             if(data.success){
    //                 this.authService.storeWebToken(data.token);
    //                 this.router.navigate(['dashboard']);
    //                 this.authService.getSurveyTypeList().subscribe(data=>{
    //                     if(data.success) {
    //                         this.cookieService.set('surveyTypeList',JSON.stringify(data.type));
    //                     }
    //                 });
    //             }
    //             else{
    //                 $.growl.error({ title: 'Error', message: data.error });
    //             }
    //             $('#btnLogin').button('reset').dequeue();
    //         });
    //     }
    //     else{
    //         this.validationService.validateAllFormFields(this.loginForm);
    //     }
    // }

    //not usable right now
    //     sendOTP(registerForm) {
    //
    //         if(this.loginForm.valid){

    //             $('#btnLogin').button('loading').queue();

    //             // if (/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(registerForm.phone)) {
    //             //     $('.btn-next').attr('disabled', 'disabled');
    // 3
    //                 this.authService.validateFields(registerForm.user_name,registerForm.password,3).subscribe(data => {
    //                     if(data.success) {
    //                         this.otpPhone = registerForm.phone;
    //                         $.growl.notice({ title: 'Success', message: "OTP SENT" });
    //                         $('.btn-sendOTP').removeAttr('disabled');
    //                         $('.btn-next').removeAttr('disabled');
    //                     }
    //                     else {
    //                         this.isFailed = true;
    //                         $.growl.Error({ title: 'Error', message:  data.error });
    //                         $('.btn-next').removeAttr('disabled');
    //                     }
    //                 });8

    //             // }
    //         }
    //     }

    closeOTPModel() {
        this.otp = null;
        //  $('#otp').value='';
        this.isFailedM = false;
    }

    verifyOTP() {

        var otp = $('#otp').val();
     
        if (otp == this.otpPhone) {

           localStorage.setItem('is_super_admin',this.is_super_admin);

            this.authService.storeWebToken(this.tempToken);
            //save data in log table
            this.authService.loggedin().subscribe(data => {
                if (data.success) {
                }
            });

            $.growl.notice({ title: 'Success', message: "Phone Verified" });


            this.router.navigate(['dashboard']);

            this.authService.getSurveyTypeList().subscribe(data => {
                if (data.success) {
                    this.cookieService.set('surveyTypeList', JSON.stringify(data.type));
                }
            });




            // //Material.wizardLoad();
            // this.isFailed = false;
            // this.varified = true;
            // this.verifyOTPForm.reset();
            // this.closeAndNext();

            // setTimeout(() => {
            // $('.btn-next').click();
            // }, 500);
        }
        else {
            this.isFailedM = true;
        }
    }


}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/user/login/login.component.ts